// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet producten-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { CollectionResultOfProductenPakkettenGetPakkettenForAdvisorDto } from '../model/collectionResultOfProductenPakkettenGetPakkettenForAdvisorDto';

import type { Result1OfProductenPakkettenGetPakketDetailsByIdPakketDto } from '../model/result1OfProductenPakkettenGetPakketDetailsByIdPakketDto';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Producten.PakkettenInzien</li></ul>
 * @summary Geeft een lijst van pakketten terug voor de ingelogde adviseur.
 */
export const pakkettenAll = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CollectionResultOfProductenPakkettenGetPakkettenForAdvisorDto>(
    { url: `/api/public/v1/pakketten`, method: 'GET', signal },
    options,
  );
};

export const getPakkettenAllQueryKey = () => {
  return ['api', 'public', 'v1', 'pakketten'] as const;
};

export const getPakkettenAllQueryOptions = <
  TData = Awaited<ReturnType<typeof pakkettenAll>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof pakkettenAll>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPakkettenAllQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof pakkettenAll>>> = ({ signal }) =>
    pakkettenAll(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof pakkettenAll>>,
    TError,
    TData
  >;
};

export type PakkettenAllQueryResult = NonNullable<Awaited<ReturnType<typeof pakkettenAll>>>;
export type PakkettenAllQueryError = ErrorType<void>;

/**
 * @summary Geeft een lijst van pakketten terug voor de ingelogde adviseur.
 */

export function usePakkettenAll<
  TData = Awaited<ReturnType<typeof pakkettenAll>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof pakkettenAll>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPakkettenAllQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Producten.PakkettenInzien</li></ul>
 * @summary Geeft pakket details terug op basis van pakketid
 */
export const pakkettenGetPakket = (
  pakketId: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  pakketId = unref(pakketId);

  return customInstance<Result1OfProductenPakkettenGetPakketDetailsByIdPakketDto>(
    { url: `/api/public/v1/pakketten/${pakketId}`, method: 'GET', signal },
    options,
  );
};

export const getPakkettenGetPakketQueryKey = (pakketId: MaybeRef<string | undefined | null>) => {
  return ['api', 'public', 'v1', 'pakketten', pakketId] as const;
};

export const getPakkettenGetPakketQueryOptions = <
  TData = Awaited<ReturnType<typeof pakkettenGetPakket>>,
  TError = ErrorType<void>,
>(
  pakketId: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof pakkettenGetPakket>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPakkettenGetPakketQueryKey(pakketId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof pakkettenGetPakket>>> = ({ signal }) =>
    pakkettenGetPakket(pakketId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => unref(pakketId) !== null && unref(pakketId) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof pakkettenGetPakket>>, TError, TData>;
};

export type PakkettenGetPakketQueryResult = NonNullable<
  Awaited<ReturnType<typeof pakkettenGetPakket>>
>;
export type PakkettenGetPakketQueryError = ErrorType<void>;

/**
 * @summary Geeft pakket details terug op basis van pakketid
 */

export function usePakkettenGetPakket<
  TData = Awaited<ReturnType<typeof pakkettenGetPakket>>,
  TError = ErrorType<void>,
>(
  pakketId: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof pakkettenGetPakket>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPakkettenGetPakketQueryOptions(pakketId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
